<template>
  <div v-if="ProgressListFriend && roundgetFriend == 0" class="leftbox" style="overflow-y: hidden !important; margin-top: 100px !important;">
    <v-layout align-center justify-center style="height: 100vh;">
      <v-progress-circular :size="100" :width="8" :indeterminate="ProgressListFriend" color="blue"></v-progress-circular>
    </v-layout>
  </div>
  <div style="overflow-y: hidden !important;" class="leftbox" v-else>
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage('/listchat/')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <h2>จัดการเพื่อน</h2>
    </v-toolbar>
    <v-flex xs12 xl12 md12 sm12 lg12 v-if="$vuetify.breakpoint.xsOnly">
      <v-list two-line v-if="listfriend.length !== 0">
        <v-layout xs12 xl12 md12 sm12 lg12 style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
          <v-text-field append-icon="search" label="ค้นหาเพื่อนโดยพิมพ์ชื่อเพื่อนหรือวันอีเมล..." solo clearable v-model="search" style="color: white !important;"></v-text-field>
        </v-layout>
        <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 250px);" class="scrolling-wrapper">
          <template v-for="(item, index) in FilterFriendList">
            <v-list-tile  avatar :key="index">
              <v-list-tile-avatar>
                <img :src="item.profilepicture" class="alligator-turtle" v-if="item.profilepicture">
                <v-img :src="require('../../assets/robot1.png')"  class="alligator-turtle" v-else></v-img>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="text2">{{ item.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.email }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn dark small class="btndelete" @click="deletefriend(item)"><v-icon small style="margin-right: 0.4em; font-size: 16px;">fas fa-minus-circle</v-icon>ลบเพื่อน</v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 < FilterFriendList.length" :key="`divider-${index}`"></v-divider>
          </template>
          <template v-if="nextgetFriend">
            <v-progress-linear :indeterminate="ProgressListFriend" v-if="ProgressListFriend"></v-progress-linear>
            <v-list-tile  avatar style="display: flex; justify-content: center;" v-else-if="search == '' || search == null">
              <v-btn @click="getlistfriendbot" style="background: #5f7c8a; color: white; border-radius: 20px;"> โหลดเพื่อนเพิ่มเติม </v-btn>
            </v-list-tile>
          </template>
        </v-flex>
      </v-list>
      <v-list v-else>
        <v-layout align-center justify-center column fill-height style="margin-top: 15%;">
          <v-img :src="require('../../assets/robot1.png')" style="width: 100px;"></v-img>
          <h4>ไม่มีรายชื่อเพื่อน</h4>
        </v-layout>
      </v-list>
    </v-flex>

    <v-flex xs12 xl12 md12 sm12 lg12  v-else>
      <div v-if="listfriend.length !== 0">
        <!-- <v-layout  style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
          <v-flex xs10 xl10 md10 sm10 lg10 offset-xs1>
            <v-text-field append-icon="search" label="ค้นหาเพื่อนโดยพิมพ์ชื่อเพื่อนหรือวันอีเมล..." solo clearable v-model="search" style="color: white !important;"></v-text-field>
          </v-flex>
        </v-layout> -->
        <v-container>
          <v-layout  style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
            <!-- <v-flex xs12 xl12 md12 sm12 lg12>
              <v-text-field append-icon="search" label="ค้นหาเพื่อนโดยพิมพ์ชื่อเพื่อนหรือวันอีเมล..." solo clearable v-model="search" style="color: white !important;"></v-text-field>
            </v-flex> -->
            <v-flex xs1 xl1 md1 sm1 lg1>
            </v-flex>
            <v-flex xs10 xl10 md10 sm10 lg10>
              <v-text-field append-icon="search" label="ค้นหาเพื่อนโดยพิมพ์ชื่อเพื่อนหรือวันอีเมล..." solo clearable v-model="search" style="color: white !important;"></v-text-field>
            </v-flex>
            <v-flex xs1 xl1 md1 sm1 lg1>
            </v-flex>
          </v-layout>
          <div style="background: #fff; max-height: 60vh;" class="scrolling-wrapper">
            <v-layout row wrap align-center >
              <v-flex sm4 md4 lg4 xl4  v-for="(item, index) in FilterFriendList" :key="index">
                <v-card class="fileCard" >
                  <div class="itemCard">
                    <v-avatar size="50">
                      <img :src="item.profilepicture" class="alligator-turtle" v-if="item.profilepicture">
                      <v-img :src="require('../../assets/robot1.png')"  class="alligator-turtle" v-else></v-img>
                    </v-avatar>
                    <v-card-text >
                      <p class="nameFriend" >{{ item.name }}</p>
                      <p>{{ item.email }}</p>
                    </v-card-text>
                    <v-divider></v-divider>
                <v-divider light></v-divider>
                  </div>
                  <v-flex style="background-color: #ab1700; color:white; cursor:pointer;"  @click="deletefriend(item)" class="pa-3">
                    <v-icon  dark small style="margin-right: 0.4em; font-size: 16px;">fas fa-minus-circle</v-icon>
                    ลบเพื่อน
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
            <template v-if="nextgetFriend">
            <v-progress-linear :indeterminate="ProgressListFriend" v-if="ProgressListFriend"></v-progress-linear>
            <v-list-tile  avatar style="display: flex; justify-content: center;" v-else-if="search == '' || search == null">
              <v-btn @click="getlistfriendbot" style="background: #5f7c8a; color: white; border-radius: 20px;"> โหลดเพื่อนเพิ่มเติม </v-btn>
            </v-list-tile>
          </template>
          </div>
        </v-container>
      </div>
      <div v-else>
        <v-layout align-center justify-center column fill-height style="margin-top: 15%;">
            <v-img :src="require('../../assets/robot1.png')" style="width: 100px;"></v-img>
            <h4>ไม่มีรายชื่อเพื่อน</h4>
          </v-layout>
      </div>
    </v-flex>
  </div>
</template>
<script>
import { sync } from 'vuex-pathify'
var _ = require('lodash')
export default {
  components: {
  },
  data: () => ({
    listEvent: [],
    isLoading: false,
    loading: false,
    listfriend: [],
    progress: false,
    search: '',
    roundgetFriend: 0,
    nextgetFriend: true,
    ProgressListFriend: false,
    FilterFriendList: []
  }),
  computed: {
    // FilterFriendList () {
    //   if (this.search !== '' && this.search !== null) {
    //     return this.listfriend.filter(post => {
    //       return post.name.toLowerCase().includes(this.search.toLowerCase())
    //     })
    //   } else {
    //     return this.listfriend
    //   }
    // },
    ...sync('*')
  },
  watch: {
    search () {
      if (this.search !== '' && this.search !== null) {
        this.searchFriend(this.search)
      } else {
        this.FilterFriendList = this.listfriend
      }
    },
    '$route.params.id' () {
      this.getlistfrienbot()
    },
    socketaccept_friend (data) {
      var tokenfriend = data.tokenfriend
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/searchtokenuser', { tokenuser: this.$route.params.id, tokenfriend: tokenfriend }).then((response) => {
        // console.log(response.data)
        if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
          this.listfriend.unshift(response.data.user)
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
      })
    }
  },
  created () {
    // this.getlistfrienbot()
    this.getlistfriendbot()
  },
  methods: {
    // getlistfrienbot () {
    //   this.progress = true
    //   this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistfriend', { tokenuser: this.$route.params.id }).then((response) => {
    //     if (response.data.status === 'success') {
    //       this.listfriend = response.data.listfriend
    //       this.progress = false
    //     } else {
    //       this.progress = true
    //     }
    //   })
    // },
    async searchFriend (search) {
      var me = this
      await setTimeout(function () {
        if (me.search !== '' && me.search !== null) {
          me.axios.post(process.env.VUE_APP_API_MANAGE + '/filter_friend', { key: me.search, tokenuser: me.$route.params.id }).then((response) => {
            if (response.data.status === 'success') {
              if (me.search !== '' && me.search !== null) {
                me.FilterFriendList = response.data.listfriend
              } else {
                me.FilterFriendList = me.listfriend
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }, 500)
    },
    getlistfriendbot () {
      if (this.nextgetFriend) {
        this.ProgressListFriend = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/listfriend_new', { tokenuser: this.$route.params.id, round_num: this.roundgetFriend.toString() }).then((response) => {
          if (response.data.status === 'success') {
          //   // console.log(response.data)
            if (response.data.listfriend.length === 20) {
              this.nextgetFriend = true
            } else {
              this.nextgetFriend = false
            }
            this.roundgetFriend = this.roundgetFriend + 1
            this.ProgressListFriend = false
            this.listfriend = this.listfriend.concat(response.data.listfriend)
            this.listfriend = _.unionBy(this.listfriend, 'tokenroom')
            this.FilterFriendList = this.listfriend
          } else {
            this.ProgressListFriend = true
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    toPage (data) {
      this.$router.push(data + this.$route.params.id)
    },
    deletefriend (item) {
      this.$swal({
        title: '',
        text: 'คุณต้องการลบ ' + item.name + ' ออกจากการเป็นเพื่อน?',
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '',
        cancelButtonColor: '',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_MANAGE + '/removefriend', { tokenfriend: item.tokenuser, tokenuser: this.$route.params.id, tokenroom: item.tokenroom }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                'ลบเพื่อนสำเร็จ.',
                'success'
              )
              var index = _.findIndex(this.listfriend, function (o) { return o.tokenuser === item.tokenuser })
              // console.log(index)
              if (index >= 0) {
                this.listfriend.splice(index, 1)
              }
            }
          })
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.swal2-popup .swal2-styled.swal2-confirm {
  border: 0 !important;
  border-radius: .25em !important;
  background: initial !important;
  background-color: #3085d6 !important;
  color: #fff !important;
  font-size: 1.0625em !important;
}
>>>.swal2-popup .swal2-styled.swal2-cancel {
  border-radius: 20px !important;
  border: 0 !important;
  border-radius: .25em !important;
  background: initial !important;
  background-color: #3a4b5394 !important;
  color: #fff !important;
  font-size: 1.0625em !important;
}
.btndelete {
  border-radius: 20px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: rgb(189, 62, 62) !important;
  background-color: rgb(189, 62, 62) !important;
  color: white !important;
  box-shadow: 2px 4px 10px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 4px 5px 0px rgba(0,0,0,0.12) !important;
}
.text2 {
  white-space: nowrap;
  width: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 300px !important;
  height: 185px !important;
  position: relative;
  background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 27px/100% arial, sans-serif;
  position: absolute;
  right: 15px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.buttonsubmit {
  background-color: #607d8b !important;
  border-radius: 8px !important;
  color: white !important;
  text-transform: none !important;
}
.buttoncancel {
  border-radius: 8px !important;
  color: #4c4c4c !important;
  text-transform: none !important;
  border-color: #8080807d !important;
  border-style: solid !important;
  border-width: thin !important;
}
.fontchat {
  color: gray;
  font-size: 12px;
}
.leftbox {
  height: calc(100vh - 64px);
  background-color: #fff !important;
  overflow: hidden;
}
>>>.v-input__slot {
  width: 100%;
  border-radius: 20px;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  height: 50px !important;
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.itemCard{
  padding-top: 10%;
}
.theme--light .v-card.fileCard {
  border: 2px solid rgba(0,0,0,0.12) !important;
  border-radius: 10px;
}
/* .theme--light .v-card.fileCard:hover .saveButton {
  display: inline-block;
} */
/* .saveButton{
  display: none;
} */
.fileCard {
  margin-bottom: 20%;
  width:200px;
  height:200px;
  margin-bottom:30px;
  display:inline-block;
}
.nameFriend{
  margin-left:auto;
  margin-right:auto;
  font-weight: bold;
  color: black !important;
  white-space: nowrap;
  width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom:2px;
}
.v-card__text {
    padding: 16px;
    padding-top: 16px;
    padding-right: 16px;
    padding-bottom: 0px;
    padding-left: 16px;
    width: 100%;
}
.deleteButton {
  display: none;
}

.theme--light .v-card.fileCard:hover .deleteButton {
  display: inline-block;
}

</style>
